import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useGetRate } from '../../../../../../hooks/useGetRate';
//--------------------------------------------------------------------------------------------
import { AddListButton } from './components/AddListButton';
import './style.scss';
import { getContentInfoLive } from '../../../../utils/getDataFromLiveVodContent';
import { getRateText } from './utils/getRateTex';
import { useSelector } from 'react-redux';

//Este componente regresa la informacion adicional como descripcion, duracion, etc,
//-visible cuando la card esta en foco-
export const AditionalInfo = ({ contentInfo }) => {
  const infoGeneral = getContentInfoLive(contentInfo);
  const { getRate } = getRateText(
    contentInfo?.rating_code || contentInfo?.channel_group?.common.rating_code,
  );
  const userHash = useSelector(state => state?.user?.userhash);


  return (
    <div className="aditional-info">
      <p className="aditional-info__description">{infoGeneral.description}</p>
      <div className="aditional-info__labels">
        <span className="labels__rating">{getRate()}</span>
        {(contentInfo?.content_type === 'P' ||
          contentInfo?.type === 'P' ||
          contentInfo?.type === 'S' ||
          contentInfo?.content_type === 'S') && (
          <Fragment>
            <span className="labels__duration">
              {moment(contentInfo?.duration, 'hh:mm:ss').format('h[h] mm [min]')}
            </span>
            {
              userHash ? (<AddListButton contentInfo={contentInfo} />) : (<div>{'                '}</div>)
            }
            
          </Fragment>
        )}
        {/*----Solo se renderiza si la card es de tipo serie o pelicula----*/}
      </div>
    </div>
  );
};

AditionalInfo.propTypes = {
  contentInfo: PropTypes.object.isRequired,
};
